import { combineReducers } from "redux";
import { retracedData } from "./reducer";

export default combineReducers({
  retracedData
});
